import React from 'react';
import { ActionButton } from '../ActionButton/ActionButton';

var A4_ActionButton = function A4_ActionButton(props) {
  return /*#__PURE__*/React.createElement(ActionButton, props);
};

export { A4_ActionButton };